/**
 * This file contains utility functions for formatting timestamps.
 * It is used to format timestamps in the order detail page and activity logs.
 */
const SECONDS_IN_MINUTE = 60;
const MINUTES_IN_HOUR = 60;
const HOURS_IN_DAY = 24;

export const formatTimestamp = (datetime: Date | string): string => {
  const date = typeof datetime === 'string' ? new Date(datetime) : datetime;
  const now = new Date();
  const timePassed = now.getTime() - date.getTime();
  const secondsPassed = Math.floor(timePassed / 1000);
  const minutesPassed = Math.floor(secondsPassed / SECONDS_IN_MINUTE);
  const hoursPassed = Math.floor(minutesPassed / MINUTES_IN_HOUR);

  if (secondsPassed < SECONDS_IN_MINUTE) {
    return `${secondsPassed}s ago`;
  }
  if (minutesPassed < MINUTES_IN_HOUR) {
    return `${minutesPassed}m ago`;
  }
  if (hoursPassed < HOURS_IN_DAY) {
    return `${hoursPassed}h ago`;
  }

  // For older dates, use simple formatted date
  return formatDate(date);
};

const formatDate = (date: Date): string => {
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  const hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const displayHours = hours % 12 || 12;
  const displayMinutes = minutes.toString().padStart(2, '0');

  return `${months[date.getMonth()]} ${date.getDate()} at ${displayHours}:${displayMinutes} ${ampm}`;
};
